import { Box, Checkbox, Form, Typography } from 'cs-kevlar-react'
import { Formik } from 'formik'
import * as React from 'react'
import { EditModalActionBar } from 'components'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import {
  ApiTokenConfigurationViewModel,
  ApiTokenViewModel,
  Guid,
  Scope,
} from 'api'
import { getAllScopes, getScopeLabel } from 'utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    formFieldContainer: {
      flexGrow: 1,
      minHeight: 0,
      overflowY: 'auto',
      padding: theme.spacing(8),
    },
    spacer: {
      flexGrow: 1,
      minHeight: 0,
    },
  }),
)

interface UpgradeTokenProps {
  apiToken: ApiTokenViewModel
  onClose: () => void
  onSubmit: (apiTokenId: Guid, newScopes: Scope[]) => void
}

const ALL_POSSIBLE_SCOPES = getAllScopes()
  .map((scope) => parseInt(scope.key))
  .filter((scope) => scope !== 0)

export const UpgradeToken: React.FunctionComponent<UpgradeTokenProps> = (
  props,
) => {
  const classes = useStyles({})
  const { onClose, onSubmit, apiToken } = props

  const [selectedScopes, setSelectedScopes] = React.useState<Scope[]>(
    apiToken.scopes,
  )

  const toggleScope = (scope: Scope) => {
    if (selectedScopes.includes(scope)) {
      setSelectedScopes([...selectedScopes.filter((x) => x !== scope)])
      return
    }

    setSelectedScopes([...selectedScopes, scope])
  }

  const onFormSubmit = () => {
    onSubmit(apiToken.apiTokenId, selectedScopes)
  }

  return (
    <Formik initialValues={{}} onSubmit={onFormSubmit}>
      {(formikProps) => (
        <Form onSubmit={formikProps.handleSubmit} className={classes.form}>
          <Box className={classes.formFieldContainer}>
            {ALL_POSSIBLE_SCOPES.map((scope) => (
              <Checkbox
                key={`UpgradeToken::Scope::${scope}`}
                label={getScopeLabel(scope)}
                id={`upgradeTokenScope${scope}`}
                checked={selectedScopes.includes(scope)}
                onChange={() => toggleScope(scope)}
              />
            ))}
          </Box>
          <Box className={classes.spacer} />
          <EditModalActionBar
            canDelete={false}
            onDelete={() => {}}
            onCancel={onClose}
            formikProps={formikProps}
            saveText="Update"
          />
        </Form>
      )}
    </Formik>
  )
}
